module.exports = __webpack_public_path__ + "static/media/icon-location-white.53912473.svg";